<template>
  <figure class="image m-0">
    <GmapMap v-if="latitude && longitude" :center="{lat: latitude, lng: longitude}" :zoom="11" map-type-id="roadmap" style=" height: 520px">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen = false"></gmap-info-window>
      <GmapMarker :position="marker.position" :clickable="true" :draggable="false" @click="toggleInfoWindow(marker)" />
    </GmapMap>
  </figure>
</template>

<script>
export default {
  name: 'GoogleMaps',
  components: {},
  props: {
    latitude: Number,
    longitude: Number,
    contact: Object,
  },
  data() {
    return {
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    }
  },
  computed: {
    marker() {
      return {
        position: {
          lat: this.latitude,
          lng: this.longitude,
        },
        infoText: `<strong>${this.contact.name}</strong><br>${this.contact.address}<br>${this.contact.country}-${this.contact.zip} ${this.contact.city}`,
      }
    },
  },
  methods: {
    toggleInfoWindow(marker) {
      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.infoText
      this.infoWinOpen = !this.infoWinOpen
    },
  },
}
</script>

<style scoped lang="scss"></style>
